"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterMedia = filterMedia;
const camelize_1 = require("./camelize");
// function to filter a set of media assets to keep only those specified in images, audio and video arguments
function filterMedia(startingAssets, images, audio, video) {
    const finalAssets = {
        images: {},
        audio: {},
        video: {},
    };
    ['images', 'audio', 'video'].forEach((string, index) => {
        const mediaType = string;
        let assetNames = [images, audio, video][index];
        // make sure assets are camel case
        assetNames = assetNames.map((asset) => (0, camelize_1.camelize)(asset));
        finalAssets[mediaType] = Object.keys(startingAssets[mediaType])
            .filter((key) => assetNames.includes((0, camelize_1.camelize)(key)))
            .reduce((acc, key) => {
            acc[key] = startingAssets[mediaType][key];
            return acc;
        }, {});
    });
    return finalAssets;
}
